import {Content} from '@radix-ui/react-collapsible';
import clsx from 'clsx';

type Props = React.ComponentProps<typeof Content>;
export function CollapsibleContent({
  className,
  ...props
}: Props): React.JSX.Element {
  const cn = clsx(className, 'px-2');

  return <Content {...props} className={cn} />;
}

CollapsibleContent.displayName = 'CollapsibleContent';
